import { SiteInfo } from '@sitecore-jss/sitecore-jss-nextjs/site';
import { loadRuntimeConfig } from 'lib/runtime-config/loadRuntimeConfig';
import { SiteResolverPlugin } from '..';

class DefaultPlugin implements SiteResolverPlugin {
  exec(sites: SiteInfo[]): SiteInfo[] {
    const { sitecoreSiteName, defaultLanguage } = loadRuntimeConfig();

    if (!sitecoreSiteName || !defaultLanguage) {
      throw new Error('Runtime config must provide sitecoreSiteName and defaultLanguage.');
    }

    // Add default/configured site
    sites.unshift({
      name: sitecoreSiteName,
      language: defaultLanguage,
      hostName: '*',
    });

    return sites;
  }
}

export const defaultPlugin = new DefaultPlugin();
